import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider, AuthProvider } from './context';
import { ToastProvider } from './components/ui';
import { AppLayout } from './components/layout';
import { PlaceholderPage, ProtectedRoute } from './components/common';
import { ChatsPage, AssistantsPage, AssistantDetailsPage, KnowledgeBasePage, IntegrationsPage, DatasourcesPage, MarketplacePage, UserTemplatesPage, AnalyticsPage, WorkflowsPage, SkillsPage, MeetingsPage, MeetingDetailPage, DeveloperAgentsPage, RepoDetailsPage, BrownfieldPage, TagsPage, SettingsPage } from './pages';
import { BillingPage } from './pages/BillingPage';
import { CreateAssistantPage } from './pages/CreateAssistantPage';
import { CreateSkillPage } from './pages/CreateSkillPage';
import { LoginPage } from './pages/LoginPage';
import { CallbackPage } from './pages/CallbackPage';
import './styles/globals.css';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppProvider>
          <ToastProvider>
            <Routes>
              {/* Public routes */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/callback" element={<CallbackPage />} />

              {/* Protected routes */}
              <Route path="/" element={<ProtectedRoute><ChatsPage /></ProtectedRoute>} />
              <Route path="/assistants" element={<ProtectedRoute><AssistantsPage /></ProtectedRoute>} />
              <Route path="/assistants/create" element={<ProtectedRoute><CreateAssistantPage /></ProtectedRoute>} />
              <Route path="/assistants/:id" element={<ProtectedRoute><AssistantDetailsPage /></ProtectedRoute>} />
              <Route path="/skills" element={<ProtectedRoute><SkillsPage /></ProtectedRoute>} />
              <Route path="/skills/create" element={<ProtectedRoute><CreateSkillPage /></ProtectedRoute>} />
              <Route path="/skills/:id/edit" element={<ProtectedRoute><CreateSkillPage /></ProtectedRoute>} />
              <Route path="/knowledge" element={<ProtectedRoute><KnowledgeBasePage /></ProtectedRoute>} />
              <Route path="/knowledge/integrations" element={<ProtectedRoute><KnowledgeBasePage /></ProtectedRoute>} />
              <Route path="/knowledge/datasources" element={<ProtectedRoute><KnowledgeBasePage /></ProtectedRoute>} />
              
              <Route path="/marketplace" element={<ProtectedRoute><MarketplacePage /></ProtectedRoute>} />
              <Route path="/my-templates" element={<ProtectedRoute><UserTemplatesPage /></ProtectedRoute>} />
              <Route path="/workflows" element={<ProtectedRoute><WorkflowsPage /></ProtectedRoute>} />
              <Route path="/meetings" element={<ProtectedRoute><MeetingsPage /></ProtectedRoute>} />
              <Route path="/meetings/:id" element={<ProtectedRoute><MeetingDetailPage /></ProtectedRoute>} />
              <Route path="/developer-agents" element={<ProtectedRoute><DeveloperAgentsPage /></ProtectedRoute>} />
              <Route path="/developer-agents/:repoId" element={<ProtectedRoute><RepoDetailsPage /></ProtectedRoute>} />
              <Route path="/brownfield" element={<ProtectedRoute><BrownfieldPage /></ProtectedRoute>} />
              <Route path="/tags" element={<ProtectedRoute><TagsPage /></ProtectedRoute>} />
              <Route path="/teams" element={<ProtectedRoute><AppLayout><PlaceholderPage title="Teams" description="Collaborate with your team members and manage permissions." /></AppLayout></ProtectedRoute>} />
              <Route path="/explore" element={<ProtectedRoute><AppLayout><PlaceholderPage title="Explore" description="Discover new features and capabilities." /></AppLayout></ProtectedRoute>} />
              <Route path="/code" element={<ProtectedRoute><AppLayout><PlaceholderPage title="Code" description="Advanced code generation and analysis tools." /></AppLayout></ProtectedRoute>} />
              <Route path="/analytics" element={<ProtectedRoute><AnalyticsPage /></ProtectedRoute>} />
              <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
              <Route path="/settings/personalization" element={<ProtectedRoute><AppLayout><PlaceholderPage title="Personalization" description="Customize your experience." /></AppLayout></ProtectedRoute>} />
              <Route path="/help" element={<ProtectedRoute><AppLayout><PlaceholderPage title="Help" description="Get help and support for using BrainIQ." /></AppLayout></ProtectedRoute>} />
              <Route path="/upgrade" element={<ProtectedRoute><BillingPage /></ProtectedRoute>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </ToastProvider>
        </AppProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;
